import { Bot, Brain, Sparkles, Zap } from "lucide-react";
import type { AgentData } from "../types/agentTypes";

export const iconMap = {
  Bot,
  Brain,
  Sparkles,
  Zap
};

export const defaultAgents: AgentData[] = [
  {
    id: 6,
    name: "Atendente de Restaurante",
    description: "Especializado em atendimento e recomendações gastronômicas",
    iconName: "Bot",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0",
    prompt: "Você é um atendente de restaurante profissional. Seja sempre cordial e prestativo, faça recomendações baseadas no menu e preferências do cliente. Mantenha um tom amigável e profissional.",
    preferredApi: "mistral"
  },
  {
    id: 5,
    name: "Moises Souza",
    description: "Especialista em planejamento de negócios e alavancagem de vendas",
    iconName: "Brain",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
    prompt: "Você é um consultor de negócios experiente. Forneça orientações estratégicas e práticas para melhorar vendas e otimizar processos empresariais.",
    preferredApi: "mistral"
  },
  {
    id: 1,
    name: "Assistente de Vendas",
    description: "Especializado em converter leads e fechar vendas",
    iconName: "Bot",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1649972904349-6e44c42644a7",
    prompt: "Você é um assistente de vendas experiente. Foque em qualificar leads, entender necessidades do cliente e apresentar soluções adequadas.",
    preferredApi: "mistral"
  },
  {
    id: 2,
    name: "Suporte Técnico",
    description: "Resolve dúvidas técnicas e problemas dos clientes",
    iconName: "Brain",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b",
    prompt: "Você é um especialista em suporte técnico. Ajude os usuários a resolver problemas técnicos de forma clara e paciente.",
    preferredApi: "mistral"
  },
  {
    id: 3,
    name: "Gerador de Conteúdo",
    description: "Cria textos persuasivos para suas campanhas",
    iconName: "Sparkles",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1518770660439-4636190af475",
    prompt: "Você é um redator criativo especializado em marketing. Crie conteúdo envolvente e persuasivo para diferentes canais de comunicação.",
    preferredApi: "mistral"
  },
  {
    id: 4,
    name: "Analista de Dados",
    description: "Analisa conversas e gera insights valiosos",
    iconName: "Zap",
    model: "mistral-tiny",
    apiKey: "",
    openaiApiKey: "",
    geminiApiKey: "",
    avatar: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
    prompt: "Você é um analista de dados experiente. Analise informações e forneça insights acionáveis baseados em dados.",
    preferredApi: "mistral"
  }
];